package horcrux.frontend.common.analytics

import horcrux.frontend.common.Route

sealed interface AnalyticsEvent {
    val eventName: String
}

class PageViewEvent(private val route: Route) : AnalyticsEvent {
    override val eventName: String by lazy {
        route.routeName.drop(0)
    }
}

enum class ScreenViewEvent(override val eventName: String): AnalyticsEvent{
    FEEDBACK_FORM("feedback"),
    QUESTION_ANSWER("question-answer"),
    RELEVANT_DOCUMENT("relevant-document"),
    DOCUMENT_DETAILS("document-details"),
    DOCUMENT_SOURCE("document-source"),
    DOCUMENT_CHUNKS("document-chunk"),
    ADVANCED_SETTINGS("advanced-settings"),
    COLLECTION_DETAILS("collection-details"),
    CREATE_COLLECTION_AND_IMPORT("create-collection-and-import"),
    CREATE_COLLECTION("create-collection"),
    DELETE_COLLECTION("delete-collection"),
    EDIT_COLLECTION_NAME("edit-collection-name"),
    IMPORT_DOCUMENTS("import-documents"),
    DELETE_DOCUMENTS("delete-documents"),
    EDIT_DOCUMENT_NAME("edit-document-name");
}
